import { formatLocaleDate } from "@/utils/formatUtils";
import { Descriptions } from "antd";
import { useTranslation } from "react-i18next";
import { TravelInsurance } from "../../../../../types";

interface Props {
  insurance: TravelInsurance;
}

const TravelInsuranceView = ({ insurance }: Props) => {
  const { t } = useTranslation();

  const { insuranceData } = insurance;

  return (
    <Descriptions
      size="small"
      bordered
      column={2}
      styles={{ label: { width: 200 } }}
      items={[
        {
          label: t("calc.travel.enums.territorialValidity._label"),
          children: t("calc.travel.enums.territorialValidity." + insuranceData.territorialValidity),
        },
        {
          label: t("calc.travel.enums.riskGroup._label"),
          children: insuranceData.riskGroup ? t("calc.travel.enums.riskGroup." + insuranceData.riskGroup) : undefined,
        },
        {
          label: t("contract.attrs.insurances.insuranceData.insuredClients._label"),
          children: insuranceData.insuredClients
            .map((client) => `${client.firstName} ${client.lastName} (${formatLocaleDate(client.birthDate)})`)
            .join(", "),
          span: 2,
        },
      ]}
    />
  );
};

export default TravelInsuranceView;
